<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getMusic()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Music class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Music</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th></th>
                                                <th>Title</th>
                                                <th>Public Music</th>
                                                <th>Total Use Of Music</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in music.data" :key="data.id" v-on:click="editMusic(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_music" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td v-on:click.stop="">
                                                    <div class="play-button mt-2 mb-2" :class="[music_play === data.id ? 'active' : '']" @click="music_play === data.id ? pauseMusic(data) : playMusic(data)">
                                                        <i v-if="music_play !== data.id || music_pause && music_play === data.id" class="w-100 uil uil-play"></i>
                                                        <i v-if="music_play === data.id && !music_pause" class="w-100 uil uil-stop-circle"></i>
                                                    </div>
                                                </td>
                                                <td>{{data.title}}</td>
                                                <td>
                                                    <label v-if="data.is_public === 'true'" class="badge badge-success"><i class="uil uil-check"></i> Yes</label>
                                                    <label v-if="data.is_public === 'false'" class="badge badge-danger"><i class="uil uil-times"></i> No</label>
                                                </td>
                                                <td>
                                                    <label class="badge badge-info">{{data.music_using_count}} Times</label>
                                                </td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="music.total === 0" class="text-center no-data">Music data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="music"
                                                :sorting="sorting"
                                                @paginate="getMusic()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Music Data Still Empty</h2>
                                    <p>On this page you can create music for event</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Music class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Music</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_music.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_music = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_music.length}}</span> music selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeleteMusic()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_music="del_music" @getMusic="_getMusic(),del_music = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../music/ModalForm.vue'
    import moment from 'moment'


    export default {
        name: "music",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_music:[],
                music_play:'',
                music_pause:false,
                music_set:new Audio(),
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this._getMusic()
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('MusicControl', {
                music: state => state.music,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.music.data ? this.del_music.length == this.music.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.music.data.forEach(function (music) {
                            if(music.id !== 1){
                                selected.push(music.id);
                            }
                        });
                    }

                    this.del_music = selected;
                }
            }
        },
        methods: {
            ...mapActions('MusicControl', ['getMusic','deleteMusic']),
            ...mapMutations('MusicControl', ['CLEAR_MUSIC','ASSIGN_FORM']),
            
            _getMusic:function(){
                this.getMusic().then(() => {
                    if(this.music.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            playMusic: function(data){
                if(!this.music_set.paused){
                    this.music_set.pause();
                    this.music_set.currentTime = 0;
                    this.music_play = data.id
                    this.music_set = new Audio(data.url);
                    this.music_set.play()
                }else{
                    this.music_play = data.id
                    this.music_set = new Audio(data.url);
                    this.music_set.play()
                }
            },
            pauseMusic: function(){
                if(!this.music_set.paused){
                    this.music_pause = true
                    this.music_set.pause()
                }else{
                    this.music_pause = false
                    this.music_set.play()
                }
            },
            editMusic:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Music')
            },
            alertDeleteMusic:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this music data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteMusic(this.del_music).then(
                            this.$toast.success('Successfully Deleting Music'),
                            this.del_music = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.music_set.pause();
            this.music_set.currentTime = 0;
            this.CLEAR_MUSIC()
        }
    };

</script>
